import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useNavigate } from 'react-router';
import { colors } from '@styles/vars';
import { LinkButton } from './style';
import { APP_NAME } from '@constants/app';

function Navbar({ isMobile, is_visible = true, logoColor = 'black' }) {
  const navigate = useNavigate();

  return (
    <AppBar
      position="static"
      sx={{
        background: isMobile ? colors.transparentColor : colors.aliceblue,
        marginBottom: '0px !important'
      }}
    >
      <Container maxWidth="xl" sx={{ zIndex: '100000' }}>
        <Toolbar
          disableGutters
          sx={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <Typography
            variant="h6"
            noWrap
            component="span"
            onClick={() => navigate('/')}
            sx={{
              mr: 2,
              fontWeight: 600,
              color: `${
                logoColor && isMobile ? logoColor : colors.black
              } !important`,
              textDecoration: 'none',
              cursor: 'pointer'
            }}
          >
            {APP_NAME}
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            {is_visible && <LinkButton to="/login">Login</LinkButton>}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default Navbar;
